import { render, staticRenderFns } from "./AppQhudong.vue?vue&type=template&id=67ffda3c&scoped=true&"
var script = {}
import style0 from "./AppQhudong.vue?vue&type=style&index=0&id=67ffda3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ffda3c",
  null
  
)

export default component.exports